import { createContext } from 'react';

import type { FaceCreateContextType } from '../types';

export const FaceCreateContext = createContext<FaceCreateContextType>({} as FaceCreateContextType);
